import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  organization: {
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: 300
  },
  image: {
    width: 40,
    height: 40,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    border: '1px solid #C8C8C8',
    flexShrink: 0
  },
  name: {
    fontSize: '1.125em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontWeight: 600,
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap'
  }
}))
